import produce from 'immer';
import {LOADER_STATUS,PROFILE_INFO,SET_OVERRIDE_DOWNLOAD,
  RESPONSE_MESSAGE,
  SET_SUMMARY_DOWNLOAD,SET_OVERRIDE_DATA,ON_GSTR_SUMMARY,SET_SAVE_GSTIN_DATA,ON_GSTR_SUMMARY_AMD,SET_NIL_DATA,SET_DOC_ISSUE_DATA,SET_HSN_DATA} from './constants';

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData:[],
  summaryData:[],
  summaryAmdData:[],
  nilData:[],
  docData:[],
  hsnData:[],
  gstrSummary:[],
  overloadedData:[],
  downloadSummaryData:[],
  overrideDowloadData:[],
  msg: '',
  status: false,
  error: 0,
};

/* eslint-disable default-case, no-param-reassign */
const saveGstr9Reducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
        case RESPONSE_MESSAGE:
          return {
            ...state,
            msg:action.msg,
            status:action.status,
            error:action.error
          }
      case PROFILE_INFO:
        return {
          ...state,
          profileData:action.profileData
        }
      case ON_GSTR_SUMMARY:
        return {
          ...state,
          summaryData:action.summaryData
        }
      case ON_GSTR_SUMMARY_AMD:
        return {
          ...state,
          summaryAmdData:action.summaryAmdData
        }
      case SET_NIL_DATA:
        return {
          ...state,
          nilData:action.nilData
        }
      case SET_DOC_ISSUE_DATA:
        return {
          ...state,
          docData:action.docData
        }
      case SET_HSN_DATA:
        return {
          ...state,
          hsnData:action.hsnData
        }
      case SET_SAVE_GSTIN_DATA:
        return {
          ...state,
          gstrSummary:action.payload
        }
      case SET_OVERRIDE_DATA:
        return {
          ...state,
          overloadedData:action.payload
        }
      case SET_SUMMARY_DOWNLOAD:
        return {
          ...state,
          downloadSummaryData:action.payload
        }
      case SET_OVERRIDE_DOWNLOAD:
        return {
          ...state,
          overrideDowloadData:action.payload
        }
      default:
        return state;
    }
  };

export default saveGstr9Reducer;
